export default {
  asset: "Assets",
  article: "Articles",
  feature: "Additional Features",
  craneParts: "Crane Parts",
  excavators: "Excavators",
  attachments: "Attachments",
  dates: "Dates",
};
